import { Component, Input } from '@angular/core';
import { IFooterModel } from '@shared/services/api/dashboard/footers-service/footers.model';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-footer-view',
    templateUrl: './footer-view.component.html',
    styleUrls: ['./footer-view.component.scss'],
})
export class FooterViewComponent {

    @Input()
    get model(): IFooterModel { return this.model$.value; }
    set model(value: IFooterModel) { this.model$.next(value); }
    public model$: BehaviorSubject<IFooterModel> = new BehaviorSubject<IFooterModel>(undefined);

    @Input()
    get language(): string { return this.language$.value; }
    set language(value: string) { this.language$.next(value); }
    public language$: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

}
